import React from 'react';
import { PromotionalBannerProps } from '../../types';
import './PromotionalBanner.css';

const PromotionalBanner: React.FC<PromotionalBannerProps> = ({ 
  message, 
  code, 
  dates, 
  note,
  onClick 
}) => {
  return (
    <div className="promotional-banner">
      <div className="banner-content">
        <div className="banner-main">
          <span className="banner-text">
            {message} - use code <strong className="banner-code">{code}</strong> at checkout!
          </span>
          
          {note && (
            <span className="banner-note">
              {note}
            </span>
          )}

          {dates && (
            <span className="banner-dates">
              {dates}
            </span>
          )}
        </div>
        <button className="banner-arrow" onClick={onClick} aria-label="Shop promotion">
          <Icon type="arrow" size="small" />
        </button>
      </div>
    </div>
  );
};

interface IconProps {
  type: 'arrow';
  size: 'small';
}

const Icon: React.FC<IconProps> = ({ type, size }) => {
  const renderIcon = (): React.ReactElement | null => {
    if (type === 'arrow') {
      return (
        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z"/>
        </svg>
      );
    }
    return null;
  };

  return renderIcon();
};

export default PromotionalBanner;
